namespace SorAraBul.Membership {

    @Serenity.Decorators.registerClass()
    export class SignUpPanel extends Serenity.PropertyPanel<SignUpRequest, any> {

        protected getFormKey() { return SignUpForm.formKey; }

        private form: SignUpForm;

        constructor(container: JQuery) {
            super(container);

            this.form = new SignUpForm(this.idPrefix);
            SorAraBul.Common.preventAutofill([
                this.form.CityId,
                this.form.IlceId
            ]);

            this.form.ConfirmPassword.addValidationRule(this.uniqueName, e => {
                if (this.form.ConfirmPassword.value !== this.form.Password.value) {
                    return Q.text('Validation.PasswordConfirm');
                }
            });

            this.byId('SubmitButton').click(e => {
                e.preventDefault();

                if (!this.validateForm()) {
                    return;
                }

                Q.serviceCall({
                    url: Q.resolveUrl('~/Account/SignUp'),
                    request: {
                        UserType: this.form.UserType.value,
                        DisplayName: this.form.DisplayName.value,
                        Email: this.form.Email.value,
                        Password: this.form.Password.value,
                        ConfirmPassword: this.form.ConfirmPassword.value,
                        MobilePhoneNumber: this.form.MobilePhoneNumber.value,
                        CompanyName: this.form.CompanyName.value,
                        TaxOffice: this.form.TaxOffice.value,
                        TaxNumber: this.form.TaxNumber.value,
                        AddressDetail: this.form.AddressDetail.value,
                        CityId: this.form.CityId.value,
                        IlceId: this.form.IlceId.value,
                        ContactNumber: this.form.ContactNumber.value,
                        PostalCode: this.form.PostalCode.value
                    },
                    onSuccess: response => {
                        Q.information(Q.text('Forms.Membership.SignUp.Success'), () => {
                            window.location.href = Q.resolveUrl('~/Account/Login');
                        });
                    }
                });

            });


            // Üyelik tipi değişince görünüm/kurallar güncellensin
            this.form.UserType.change(() => this.updateCompanySection());

            // İlk yüklemede de doğru görünüm
            this.updateCompanySection();
        }

        private updateCompanySection() {
            const isCorporate = Q.toId(this.form.UserType.value) == UserType.kurumsal; // 2: kurumsal

            // Kurumsal/Adres alanları (senin alan adların)
            const corpEditors: Serenity.Widget<any>[] = [
                this.form.CompanyName,
                this.form.TaxOffice,
                this.form.TaxNumber,
                this.form.AddressDetail,
                this.form.CityId,
                this.form.IlceId,
                this.form.ContactNumber,
                this.form.PostalCode
            ];

            for (const ed of corpEditors) {
                // Satırı göster/gizle
                (ed as any).getGridField
                    ? (ed as any).getGridField().toggle(isCorporate)
                    : ed.element.closest('.field').toggle(isCorporate);

                // Zorunluluk durumunu aç/kapa
                Serenity.EditorUtils.setRequired(ed, isCorporate);

                // Bireyselde alanları temizlemek (önerilir)
                if (!isCorporate) {
                    Serenity.EditorUtils.setValue(ed, null); // değeri temizle
                }
            }

            Serenity.EditorUtils.setRequired(this.form.PostalCode, false);
        }
    }
}
